<template>
  <!-- TODO get rid of this padding handling-->
  <v-container class="mt-4 mb-6" fluid
               v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
    <v-row>
      <v-col cols="12">
        <div class="mt-6">
          <h1>Backtesting</h1>
        </div>
      </v-col>
      <v-col cols="12">
        <p>Hier kannst Du den Kauf deines Portfolios zurückdatieren und dessen fiktive Performance vergleichen.</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <fin-data-loader :resolver="loadData" class="mt-6">
          <template #content="{data}">
            <p v-if="data.items.length === 0" style="max-width: 700px">
              Du hast noch kein Portfolio. Nachdem du Portfolios angelegt hast, kannst Du hier rückwirkend die
              Kursentwicklungen deiner Portfolios untersuchen.</p>
            <div v-else>
              <fin-select-box v-model="selectedPortfolio"
                              label="Portfolio"
                              :items="data.items"
                              class="mb-2 mb-sm-8"
                              return-as-object
                              selectBoxItemTitle="name"
                              selectBoxItemValue="id"
                              style="max-width: 350px;"
              />
              <p v-if="!portfolioHasInstruments">
                Dein Portfolio hat keine Wertpapiere. Wähle bitte ein anderes Portfolio aus.</p>
              <fin-portfolio-backtesting :portfolio-data="selectedPortfolio" v-else-if="selectedPortfolio"/>
              <div v-else>Bitte wähle ein Portfolio</div>
            </div>
          </template>
        </fin-data-loader>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import FinPortfolioBacktesting from "@/components/pages/myPortfolio/PortfolioBacktesting"
import FinDataLoader from "@/components/common/DataLoader"
import {mapGetters} from "vuex"
import FinSelectBox from "@/components/common/SelectBox"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {getPortfolios_ForBacktesting} from "@/components/pages/finTools/finAnalyzer/backtesting/graphql"

export default {
  name: "FinPerformanceAnalyzer2",
  components: {FinSelectBox, FinDataLoader, FinPortfolioBacktesting},
  data: () => ({
    selectedPortfolio: null
  }),
  computed: {
    ...mapGetters('auth', ['userId']),
    portfolioHasInstruments() {
      return this.selectedPortfolio &&
        this.selectedPortfolio.shareEntries.items.length + this.selectedPortfolio.etfEntries.items.length > 0
    },
  },
  methods: {
    async loadData() {
      // we only need the names and ids of the portolios
      const result = await API.graphql(graphqlOperation(getPortfolios_ForBacktesting, {
        owner: this.userId // TODO, nextToken: nextToken
      }))
      const userPortfolios = result.data.listPortfoliosByOwner
      console.log("userPortfolios", userPortfolios)
      if (userPortfolios) {
        this.selectedPortfolio = userPortfolios.items.length > 0 ? userPortfolios.items[0] : null
        console.log("this.selectedPortfolio", this.selectedPortfolio)
      }
      return userPortfolios
    }
  }
}
</script>

<style scoped>

</style>
